module.exports = function() {
    return window.innerWidth < 769;
};